<template>

    <div>

        <div class="row row-cols-1 row-cols-lg-2 g-4">

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Category') }}</legend>
                            <checkbox-input label="enabled" v-model="form.enabled" :error="form.errors.enabled" />

                            <multi-select-input
                                v-model="form.parent_id" 
                                value-consists-of="ALL"
                                sort-value-by="INDEX"
                                :multiple="false" 
                                :is-default-expanded="true" 
                                :default-expand-level="3" 
                                :options="categoryOptions" 
                                :placeholder="__('Search')"
                                label="parent_id"
                                :error="form.errors.parent_id"
                                />

                            <text-input label="name" v-model="form.name" :error="form.errors.name" />
                            <text-input label="slug" v-model="form.slug" :error="form.errors.slug" />
                            <text-input type="number" label="sort_order" v-model="form.sort_order" :error="form.errors.sort_order" />
                            <textarea-input label="keywords" v-model="form.keywords" :error="form.errors.keywords" />
                            <textarea-input label="notes" v-model="form.notes" :error="form.errors.notes" />
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Seiteninhalt') }}</legend>
                            <editor-input label="description" v-model="form.description" :error="form.errors.description" />
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Misc') }}</legend>
                            <checkbox-input label="mdr_classified_products" v-model="form.mdr_classified_products" :error="form.errors.mdr_classified_products" />
                            <checkbox-input label="hazardous_material_products" v-model="form.hazardous_material_products" :error="form.errors.hazardous_material_products" />
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('SEO') }}</legend>
                            <text-input label="meta_title" v-model="form.meta_title" :error="form.errors.meta_title" />
                            <textarea-input label="meta_description" v-model="form.meta_description" :error="form.errors.meta_description" />
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Bilder') }}</legend>
                            <text-input label="image_id" v-model="form.image_id" :error="form.errors.image_id" />
                            <!-- @todo <attachment-selector v-model="form.image_id" :error="form.errors.image_id" max="1" />-->
                            <text-input label="default_product_image_id" v-model="form.default_product_image_id" :error="form.errors.default_product_image_id" />
                            <!-- @todo <attachment-selector v-model="form.default_product_image_id" :error="form.errors.default_product_image_id" max="1" />-->
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="d-flex align-items-center w-100">
                <submit-button :form="form" />
                <button type="button" class="btn link-danger" @click="destroy" v-if="category">
                    {{ __('Löschen') }}
                </button>
            </div>

        </div>

    </div>

</template>

<script>
    import TextInput from '@/shared/Inputs/TextInput';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import EditorInput from '@/shared/Inputs/EditorInput';
    import PercentInput from '@/shared/Inputs/PercentInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';
    import AttachmentSelector from '@/shared/Inputs/AttachmentSelector';
    import MultiSelectInput from '@/shared/Inputs/MultiSelectInput';

    export default {
        props: [
            'form',
            'category',
            'categoryOptions',
        ],
        data() {
            return {

            }
        },
        components: {
            TextInput,
            SelectInput,
            TextareaInput,
            CheckboxInput,
            EditorInput,
            PercentInput,
            SubmitButton,
            AttachmentSelector,
            MultiSelectInput
        },
        watch: {
        },
        methods: {
            destroy() {
                if (confirm(this.__('Sind Sie sicher?'))) {
                    this.$inertia.delete(this.route('admin.categories.destroy', this.category));
                }
            },
        },
    }
</script>
